import React from 'react';

const Terms = () => {
	return (
		<div className="bg-ofg-light-green">
			<div className="container mx-auto leading-6 px-7 py-28 font-redhat text-ofg-light-tan">
				<h1 className="mb-10 text-6xl font-light">
					One Fang Digital <br />
					<span className="font-extrabold">Terms and Conditions</span>
				</h1>
				<p className="w-full mb-5 xl:max-w-1/2">Last Updated: 7th Feb 2024</p>
				<p className="w-full mb-5 xl:max-w-1/2">
					Welcome to One Fang Digital! These Terms and Conditions ("Terms")
					govern your use of our website and services. By accessing or using our
					website, you agree to be bound by these Terms. If you do not agree
					with any part of these Terms, you may not use our website or services.
				</p>
				<h3 className="mb-5 text-3xl font-bold">1. Use of Our Website</h3>
				<p className="w-full mb-5 xl:max-w-1/2">
					1.1 You must be at least 18 years old to use our website. By using our
					website, you represent that you are at least 18 years old.
				</p>
				<p className="w-full mb-5 xl:max-w-1/2">
					1.2 You agree to use our website for lawful purposes only and not to
					engage in any activity that violates any applicable laws or
					regulations.
				</p>
				<p className="w-full mb-5 xl:max-w-1/2">
					1.3 We reserve the right to modify or discontinue our website at any
					time without prior notice.
				</p>
				<h3 className="mb-5 text-3xl font-bold">2. Intellectual Property</h3>
				<p className="w-full mb-5 xl:max-w-1/2">
					2.1 All content, trademarks, logos, and other intellectual property
					rights on our website are owned by or licensed to One Fang Digital.
				</p>
				<p className="w-full mb-5 xl:max-w-1/2">
					2.2 You may not use, reproduce, modify, or distribute any content from
					our website without our prior written consent.
				</p>
				<h3 className="mb-5 text-3xl font-bold">3. User Accounts</h3>
				<p className="w-full mb-5 xl:max-w-1/2">
					3.1 In order to access certain features of our website, you may be
					required to create a user account. You are responsible for maintaining
					the confidentiality of your account and password and for restricting
					access to your account.
				</p>
				<p className="w-full mb-5 xl:max-w-1/2">
					3.2 You agree to provide accurate and complete information when
					creating your user account and to update your information as necessary
					to keep it accurate and complete.
				</p>
				<h3 className="mb-5 text-3xl font-bold">4. Limitation of Liability</h3>
				<p className="w-full mb-5 xl:max-w-1/2">
					4.1 To the fullest extent permitted by law, One Fang Digital shall not
					be liable for any direct, indirect, incidental, special, or
					consequential damages arising out of or in any way connected with your
					use of our website or services.
				</p>
				<p className="w-full mb-5 xl:max-w-1/2">
					4.2 We do not warrant that our website will be uninterrupted or
					error-free, or that defects will be corrected.
				</p>
				<h3 className="mb-5 text-3xl font-bold">5. Indemnification</h3>
				<p className="w-full mb-5 xl:max-w-1/2">
					5.1 You agree to indemnify and hold harmless One Fang Digital, its
					affiliates, and their respective officers, directors, employees, and
					agents from and against any and all claims, liabilities, damages,
					losses, or expenses, including reasonable attorneys' fees and costs,
					arising out of or in any way connected with your use of our website or
					services.
				</p>
				<h3 className="mb-5 text-3xl font-bold">6. Governing Law</h3>
				<p className="w-full mb-5 xl:max-w-1/2">
					6.1 These Terms shall be governed by and construed in accordance with
					the laws of the United Kingdom, without regard to its conflict of law
					provisions.
				</p>
				<h3 className="mb-5 text-3xl font-bold">7. Changes to These Terms</h3>
				<p className="w-full mb-5 xl:max-w-1/2">
					7.1 We reserve the right to update or modify these Terms at any time
					without prior notice. Any changes will be effective immediately upon
					posting the revised Terms on our website. Your continued use of our
					website after any such changes constitutes your acceptance of the new
					Terms.
				</p>
				<h3 className="mb-5 text-3xl font-bold">8. Contact Us</h3>
				<p className="w-full mb-5 xl:max-w-1/2">
					8.1 If you have any questions or concerns about these Terms, please
					contact us at{' '}
					<a href="mailto:contact@onefanggang.com" target="_new">
						contact@onefanggang.com
					</a>
					.
				</p>
				<p className="w-full mb-5 xl:max-w-1/2">
					Thank you for using One Fang Digital!
				</p>
				<p className="w-full  xl:max-w-1/2">One Fang Digital</p>
			</div>
		</div>
	);
};

export default Terms;
